import * as React from "react";
import {cx} from "emotion";

import "./edit-action-in-table.scss";

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {omit}      from "@Common/utils/objects";

import {Tooltip2} from "../../tooltip-2/tooltip-2";

export const EditActionInTable = ({onClick, active=undefined, xdQaName=undefined, disabled, tooltip}) => cs(
    ["tooltip", (_, next) => !tooltip ? next() : Tooltip2({
        getMessage: () => tooltip,
        direction: "south-west",
        next,
    })],
    ({tooltip}, next) => fragments(
        next(),
        tooltip?.render(),
    ),
    ({tooltip}) => (
        <i {...{
            className: cx("edit-action-in-table-8vi fa fa-pencil edit", {
                disabled,
                active
            }),
            ...omit(tooltip, ["render"]),
            ...!disabled && {
                onClick,
            },
            "xd-qa-type": "icon",
            "xd-qa-name": xdQaName + " Edit",
        }}/>
    ),
);

